export default {
  data () {
    return {
      columns: [
        {
          label: 'Имя',
          field: 'name',
          name: 'name',
          sortable: true,
          filter: '',
          align: 'left',
        },
        {
          label: 'Алиас',
          field: 'alias',
          name: 'alias',
          sortable: true,
          filter: '',
          align: 'left',
        },
        {
          label: 'По умолчанию',
          field: 'is_default',
          name: 'is_default',
          sortable: true,
          filter: '',
          align: 'left',
        },
        {
          label: 'Включен',
          field: 'enabled',
          name: 'enabled',
          sortable: true,
          filter: '',
          align: 'left',
        },
        {
          label: 'Ред.',
          name: 'edit',
          field: 'id',
          align: 'right',
        },
      ],
    }
  },
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/ServiceProviders/mixins/columns.js